import { Component, OnInit } from '@angular/core';

import { DialogColors, DialogTranslations } from '../../config';
import { DialogResult } from '../../models/dialog.result';
import { DialogBehaviorService } from '../../services/dialog-behavior.service';
import { DialogDataService } from '../../services/dialog-data.service';

@Component({
  selector: 'mw-dialog-confirm-button',
  template: `<button
    mat-flat-button
    [color]="color"
    [disabled]="disabled || inProgress"
    (click)="onClick()"
    *ngIf="translations.yesButton"
    cdkFocusInitial
  >
    <div class="!flex items-center justify-center gap-2">
      <mat-spinner
        *ngIf="inProgress"
        color="accent"
        diameter="18"
        strokeWidth="3"
        class="mr-[8px]"
      ></mat-spinner>
      {{ translations.yesButton | translate : translations.title_params }}
    </div>
  </button>`,
})
export class ConfirmButtonComponent implements OnInit {
  disabled = false;
  inProgress = false;
  translations: DialogTranslations;
  color: 'warn' | 'accent';
  constructor(
    private readonly dataService: DialogDataService,
    private behaviorService: DialogBehaviorService
  ) {}

  ngOnInit(): void {
    this.translations = this.dataService.translations;
    this.color =
      this.dataService.colors === DialogColors.Warn ? 'warn' : 'accent';
    this.dataService
      .getDisabledState('confirmButton')
      .subscribe((disabled) => (this.disabled = disabled));

    this.dataService
      .getInProgressState('confirmButton')
      .subscribe((inProgress) => (this.inProgress = inProgress));
  }

  onClick(): void {
    this.dataService
      .getPreActions('confirmButton')
      .forEach((action) => action());

    this.behaviorService.onConfirmClicked.next();

    if (this.dataService.autoClose) {
      this.behaviorService.closeDialog.next(DialogResult.Confirm);
    }
  }
}
